'use client';

import { computePosition, flip, shift } from '@floating-ui/dom';
import { ReactRenderer, posToDOMRect } from '@tiptap/react';

import { MentionList } from './mention-list';

const updatePosition = (editor, element) => {
  const virtualElement = {
    getBoundingClientRect: () =>
      posToDOMRect(editor.view, editor.state.selection.from, editor.state.selection.to),
  };

  computePosition(virtualElement, element, {
    placement: 'bottom-start',
    strategy: 'absolute',
    middleware: [shift(), flip()],
  }).then(({ x, y, strategy }) => {
    Object.assign(element.style, {
      width: 'max-content',
      position: strategy,
      left: `${x}px`,
      top: `${y}px`,
    });
  });
};

export default function createMentionSuggestion({ data }) {
  return {
    items: ({ query }) =>
      data.filter((item) => item.key.toLowerCase().startsWith(query.toLowerCase())).slice(0, 5),

    render: () => {
      let reactRenderer;

      return {
        onStart: (props) => {
          if (!props.clientRect) return;

          reactRenderer = new ReactRenderer(MentionList, {
            props: {
              ...props,
              command: (item) => {
                props.command({
                  id: item.key, // insert `key` into document
                  // label: item.name, // optionally store `name` as label
                });
              },
            },
            editor: props.editor,
          });

          reactRenderer.element.style.position = 'absolute';
          document.body.appendChild(reactRenderer.element);
          updatePosition(props.editor, reactRenderer.element);
        },

        onUpdate(props) {
          reactRenderer.updateProps({
            ...props,
            command: (item) => {
              props.command({
                id: item.key,
                // label: item.name,
              });
            },
          });

          if (!props.clientRect) return;
          updatePosition(props.editor, reactRenderer.element);
        },

        onKeyDown(props) {
          if (props.event.key === 'Escape') {
            reactRenderer.destroy();
            reactRenderer.element.remove();
            return true;
          }

          return reactRenderer.ref?.onKeyDown?.(props);
        },

        onExit() {
          reactRenderer.destroy();
          reactRenderer.element.remove();
        },
      };
    },
  };
}
